import React from "react";
import {
  Card,
  Input,
  Radio,
  Icon,
} from "semantic-ui-react";
import { Label, Col, Row, CardBody } from "reactstrap";
import { withNamespaces } from "react-i18next";
import Table from "../../../../OBL/Components/Table";

function Calculadora(props) {
  let [isChecked, setIsChecked] = React.useState("aereo");
  let [longitudInput, setLongitudInput] = React.useState("");
  let [anchoInput, setAnchoInput] = React.useState("");
  let [alturaInput, setAlturaInput] = React.useState("");
  let [pesoInput, setPesoInput] = React.useState("");
  let [, setCbmInput] = React.useState("");

  let [tipoContenedor, setTipoContenedor] = React.useState("");
  let [containerLabel, setContainerLabel] = React.useState("");

  let [cajasInput, setCajasInput] = React.useState("1");

  let [, setAereoCardResult] = React.useState([]);
  let [, setTerrestreCardResult] = React.useState([]);




  let [aereoResult, setAereoResult] = React.useState([]);
  let [terrestreResult, setTerrestreResult] = React.useState([]);
  let [maritimoResult, setMaritimoResult] = React.useState([]);
  let [, setcolorEnvelopAereo] = React.useState("");
  let [, setcolorEnvelopTerrestre] = React.useState("");
  let [, setColorEnvelopMaritimo] = React.useState("");
  let [countAereo, setCountAereo] = React.useState(0);
  let [countTerrestre, setCountTerrestre] = React.useState(0);

  function Validator(params) {
    // return new RegExp(/^\d*\.?\d*$/).test(params)
    return new RegExp(/^(?:(0\.\d*)|([1-9]\.?\d*)|([1-9]*0*?\.\d*)|(0?\.?))$/).test(params)

  }


  const handleChange = (value) => {
    setIsChecked(value);
    /* aereo */
    setLongitudInput("");
    setAnchoInput("");
    setAlturaInput("");
    setPesoInput("");
    setCajasInput("1");
  };

  const mCalcular = () => {
    if (isChecked === "aereo") {
      let pesoOb = {
        ind: countAereo,
        Dimensiones: `${longitudInput} x ${anchoInput} x ${alturaInput}`,
        Peso: pesoInput,
        Cajas: cajasInput,
        Volumen: ((longitudInput * anchoInput * alturaInput) / 1e6) * cajasInput,
        PesoTotal: pesoInput * cajasInput,
        PesoVolumetrico: (longitudInput * anchoInput * alturaInput * cajasInput) / 6000,
      };
      setCountAereo(countAereo + 1);
      setcolorEnvelopAereo("#0560FC");

      aereoResult.push(pesoOb);
      // setAereoResult([...aereoResult, pesoOb]);
      // aereoCardResult.push(pesoOb)
      buildCard();
    }

    if (isChecked === "terrestre") {
      let pesoOb = {
        ind: countTerrestre,
        Dimensiones: `${longitudInput} x ${anchoInput} x ${alturaInput}`,
        Peso: pesoInput,
        Cajas: cajasInput,
        Volumen: ((longitudInput * anchoInput * alturaInput) / 1e6) * cajasInput,
        PesoTotal: pesoInput * cajasInput,
        PesoVolumetrico: (longitudInput * anchoInput * alturaInput * cajasInput) / 3000,
      };
      setCountTerrestre(countTerrestre + 1);
      setcolorEnvelopTerrestre("#0560FC");

      terrestreResult.push(pesoOb);
      // setAereoResult([...aereoResult, pesoOb]);
      // aereoCardResult.push(pesoOb)
      buildCard();
    }

    if (isChecked === "maritimo") {
      setCountAereo(countAereo + 1);
      setContainerLabel(tipoContenedor.label);
      setColorEnvelopMaritimo("#0560FC");

      let noCajas;

      // la longitud el ancho y el largo esta dado en cm el resultado se
      // muestra en m3 por ello se divide entre 1e+6
      let dimensiones = longitudInput * anchoInput * alturaInput;
      let cbm = dimensiones / 1e6;
      let totalVolume = cbm * cajasInput;
      let pesoVolumetrico = (dimensiones * cajasInput) / 5000;
      let pesoTotal = pesoInput * cajasInput;

      if (tipoContenedor.value === "2stdr") {
        noCajas = Math.trunc(Math.round(1165 / 35.315 / cbm));
      }
      if (tipoContenedor.value === "4stdr") {
        noCajas = Math.trunc(Math.round(2350 / 35.315 / cbm));
      }
      if (tipoContenedor.value === "40hcd") {
        noCajas = Math.trunc(Math.round(2694 / 35.315 / cbm));
      }
      if (tipoContenedor.value === "45hcd") {
        noCajas = Math.trunc(Math.round(3043 / 35.315 / cbm));
      }

      let pesoOb = {
        ind: countAereo,
        Dimensiones: `${longitudInput} x ${anchoInput} x ${alturaInput}`,
        Cajas: cajasInput,
        CBM: cbm,
        VolumenTotal: totalVolume,
        PesoTotal: pesoTotal,
        PesoVolumetrico: pesoVolumetrico,
        totalCajas: noCajas,
      };

      // console.log(pesoOb);

      setCbmInput(pesoOb.CBM);

      if (containerLabel && tipoContenedor.label !== containerLabel) {
        setMaritimoResult([pesoOb]);
      } else {
        setMaritimoResult([...maritimoResult, pesoOb]);
        buildCard([...maritimoResult, pesoOb]);
      }
    }
  };

  function buildCard(params) {
    // console.log("terrestreResult-->", terrestreResult);
    // console.log("isChecked", isChecked)
    // if (params) {
    //   setAereoResult(params);
    // }

    let cardResult = [];
    if (isChecked === "aereo") {
      params
        ? (cardResult = params.map((e, i) => {
          return (
            <div className="col-xs-12">
              <CardBody>
                <center>
                  <Row>
                    <Col xs={12}>
                      <div className="calculadora-title">{props.t("dimensions")}</div>
                      <div>{e.Dimensiones}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("total_volumen_m3")}
                      </div>
                      <div>{e.Volumen}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">{props.t("total_weight_kg")}</div>
                      <div>{e.PesoTotal}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("volumetric_weight_kg")}
                      </div>
                      <div>{e.PesoVolumetrico}</div>
                    </Col>
                    <Col xs={12}>
                      <Row>
                        <Col
                          md={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Icon
                            link
                            style={{ color: "red" }}
                            name="close"
                            onClick={() => removeItem(e)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </center>
                <hr></hr>
              </CardBody>
            </div>
          );
        }))
        : (cardResult = aereoResult.map((e, i) => {
          return (
            <div className="col-xs-12">
              <CardBody>
                <center>
                  <Row>
                    <Col xs={12}>
                      <div className="calculadora-title">{props.t("dimensions")}</div>
                      <div>{e.Dimensiones}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("total_volumen_m3")}
                      </div>
                      <div>{e.Volumen}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">{props.t("total_weight_kg")}</div>
                      <div>{e.PesoTotal}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("volumetric_weight_kg")}
                      </div>
                      <div>{e.PesoVolumetrico}</div>
                    </Col>
                    <Col xs={12}>
                      <Row>
                        <Col
                          md={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Icon
                            link
                            style={{ color: "red" }}
                            name="close"
                            onClick={() => removeItem(e)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </center>
                <hr></hr>
              </CardBody>
            </div>
          );
        }));
      setAereoCardResult(cardResult);
    }
    else if (isChecked === "terrestre") {
      params
        ? (cardResult = params.map((e, i) => {
          return (
            <div className="col-xs-12">
              <CardBody>
                <center>
                  <Row>
                    <Col xs={12}>
                      <div className="calculadora-title">{props.t("dimensions")}</div>
                      <div>{e.Dimensiones}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("total_volumen_m3")}
                      </div>
                      <div>{e.Volumen}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">{props.t("total_weight_kg")}</div>
                      <div>{e.PesoTotal}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("volumetric_weight_kg")}
                      </div>
                      <div>{e.PesoVolumetrico}</div>
                    </Col>
                    <Col xs={12}>
                      <Row>
                        <Col
                          md={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Icon
                            link
                            style={{ color: "red" }}
                            name="close"
                            onClick={() => removeItem(e)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </center>
                <hr></hr>
              </CardBody>
            </div>
          );
        }))
        : (cardResult = terrestreResult.map((e, i) => {
          return (
            <div className="col-xs-12">
              <CardBody>
                <center>
                  <Row>
                    <Col xs={12}>
                      <div className="calculadora-title">{props.t("dimensions")}</div>
                      <div>{e.Dimensiones}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("total_volumen_m3")}
                      </div>
                      <div>{e.Volumen}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">{props.t("total_weight_kg")}</div>
                      <div>{e.PesoTotal}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("volumetric_weight_kg")}
                      </div>
                      <div>{e.PesoVolumetrico}</div>
                    </Col>
                    <Col xs={12}>
                      <Row>
                        <Col
                          md={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Icon
                            link
                            style={{ color: "red" }}
                            name="close"
                            onClick={() => removeItem(e)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </center>
                <hr></hr>
              </CardBody>
            </div>
          );
        }));
      setTerrestreCardResult(cardResult);
    } else {
      cardResult = params.map((e, i) => {
        return (
          <div className="col-xs-12">
            <CardBody>
              <center>
                <Row>
                  <Col xs={12}>
                    <div className="calculadora-title">{props.t("dimensions")}</div>
                    <div>{e.Dimensiones}</div>
                  </Col>
                  <Col xs={12}>
                    <div className="calculadora-title">{props.t("boxes")}</div>
                    <div>{e.Cajas}</div>
                  </Col>
                  <Col xs={12}>
                    <div className="calculadora-title">{props.t("cbm_m3_2")}</div>
                    <div>{e.CBM}</div>
                  </Col>
                  <Col xs={12}>
                    <div className="calculadora-title">{props.t("total_volumen_m3")}</div>
                    <div>{e.VolumenTotal}</div>
                  </Col>
                  <Col xs={12}>
                    <div className="calculadora-title">{props.t("total_weight_kg")}</div>
                    <div>{e.PesoTotal}</div>
                  </Col>
                  <Col xs={12}>
                    <div className="calculadora-title">
                      {props.t("volumetric_weight_kg")}
                    </div>
                    <div>{e.PesoVolumetrico}</div>
                  </Col>
                </Row>
              </center>
              <hr></hr>
            </CardBody>
          </div>
        );
      });
    }
  }

  const handleEraser = () => {
    setLongitudInput("");
    setAnchoInput("");
    setAlturaInput("");
    setPesoInput("");
    setCajasInput(1);
    setCbmInput("");
    setTipoContenedor("");

    if (isChecked === "maritimo") {
      // setContainerLabel("");
      // setMaritimoResult([]);
      // setColorEnvelopMaritimo("");
    }
  };

  const removeItem = (value) => {
    if (isChecked === "aereo") {
      let deleteItem = aereoResult.filter((item) => item.ind !== value.ind);
      // aereoResult.push(deleteItem)
      setAereoResult(deleteItem);
      buildCard(deleteItem);
      if (aereoResult.length === 1) {
        setcolorEnvelopAereo("");
      }
    }
    if (isChecked === "terrestre") {
      let deleteItem = terrestreResult.filter((item) => item.ind !== value.ind);
      // aereoResult.push(deleteItem)
      setTerrestreResult(deleteItem);
      buildCard(deleteItem);
      if (terrestreResult.length === 1) {
        setcolorEnvelopTerrestre("");
      }
    }

    if (isChecked === "maritimo") {
      let deleteItem = maritimoResult.filter((item) => item.ind !== value.ind);
      setMaritimoResult(deleteItem);
      if (maritimoResult.length === 1) {
        setColorEnvelopMaritimo("");
      }
    }
  };

  const columnsTable = [
    { label: props.t("dimensions"), key: "Dimensiones", position: "left" },
    {
      label: props.t("total_volumen_m3"),
      key: "Volumen",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "center",
    },
    {
      label: props.t("total_weight_kg"),
      key: "PesoTotal",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "right",
    },
    {
      label: props.t("boxes"),
      key: "Cajas",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "right",
    },
    {
      label: props.t("volumetric_weight_kg"),
      key: "PesoVolumetrico",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "left",
    },
    {
      label: "",
      key: "removeItem",
      custom: (value) => (
        <Col md={12} xl={12}>
          <Row>
            <Col md={12} style={{ display: "flex", alignItems: "center" }}>
              <Icon
                link
                style={{ color: "red" }}
                name="close"
                onClick={() => removeItem(value)}
              />
            </Col>
          </Row>
        </Col>
      ),
    },
  ];

  const columnsTableTerrestre = [
    { label: props.t("dimensions"), key: "Dimensiones", position: "left" },
    {
      label: props.t("total_volumen_m3"),
      key: "Volumen",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "center",
    },
    {
      label: props.t("total_weight_kg"),
      key: "PesoTotal",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "right",
    },
    {
      label: props.t("boxes"),
      key: "Cajas",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "right",
    },
    {
      label: props.t("volumetric_weight_kg"),
      key: "PesoVolumetrico",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "left",
    },
    {
      label: "",
      key: "removeItem",
      custom: (value) => (
        <Col md={12} xl={12}>
          <Row>
            <Col md={12} style={{ display: "flex", alignItems: "center" }}>
              <Icon
                link
                style={{ color: "red" }}
                name="close"
                onClick={() => removeItem(value)}
              />
            </Col>
          </Row>
        </Col>
      ),
    },
  ];

  const tableMaritimo = [
    {
      label: props.t("dimensions"),
      key: "Dimensiones",
      idTh: "firstTh",
      idTd: "firstTd",
    },
    { label: props.t("boxes"), key: "Cajas", idTh: "firstTh", idTd: "firstTd" },
    { label: props.t("cbm_m3_2"), key: "CBM", idTh: "firstTh", idTd: "firstTd" },
    {
      label: props.t("total_volumen_m3"),
      key: "VolumenTotal",
      idTh: "firstTh",
      idTd: "firstTd",
    },
    {
      label: props.t("total_weight_kg"),
      key: "PesoTotal",
      idTh: "firstTh",
      idTd: "firstTd",
    },
    {
      label: props.t("volumetric_weight_kg"),
      key: "PesoVolumetrico",
      idTh: "firstTh",
      idTd: "firstTd",
    },
    // {
    //   label: "Numero de Cajas",
    //   key: "totalCajas",
    //   idTh: "firstTh",
    //   idTd: "firstTd",
    // },
    {
      label: "",
      key: "removeItem",
      custom: (value) => (
        <Col md={12} xl={12}>
          <Row>
            <Col md={12} style={{ display: "flex", alignItems: "center" }}>
              <Icon
                link
                style={{ color: "red" }}
                name="close"
                onClick={() => removeItem(value)}
              />
            </Col>
          </Row>
        </Col>
      ),
    },
  ];

  let cbmValue =
    longitudInput && anchoInput && alturaInput
      ? (longitudInput * anchoInput * alturaInput) / 1e6
      : "";

  const aereo = () => {
    return (
      <div className="row">
        <div className="col-12">
          {/* {isChecked === "maritimo" ? (
            <>
              <div className="row">
                <div
                  className="col-4"
                  style={{ paddingRight: "0", textAlign: "left" }}
                >
                  <Label>{props.t("container_type")}</Label>
                </div>
                <div className="col-8">
                  <Select
                    placeholder={props.t("container_type")}
                    value={tipoContenedor}
                    onChange={(selectValue) => setTipoContenedor(selectValue)}
                    options={containerType}
                  />
                </div>
              </div>
              <br />
            </>
          ) : (
            ""
          )} */}
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-4">
              <Label>{props.t("length_cm")}</Label>
            </div>
            <div className="col-5">
              <Input
                fluid
                value={longitudInput}
                placeholder='0'
                // type="number"
                onChange={(e, { value }) => {
                  let res = Validator(value)
                  if (res) {
                    setLongitudInput(value)
                  }
                }}
              />
            </div>
            <div className="col-3">
              <Label>cm</Label>
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-4" /* style={{padding:'0'}} */>
              <Label>{props.t("width_cm")}</Label>
            </div>
            <div className="col-5 col-md-5 col-lg-5 col-lg-5">
              <Input
                fluid
                value={anchoInput}
                placeholder='0'
                // type="number"
                // onChange={(e, { value }) => setAnchoInput(value)}
                onChange={(e, { value }) => {
                  let res = Validator(value)
                  if (res) {
                    setAnchoInput(value)
                  }
                }}
              />
            </div>
            <div className="col-3 col-md-3 col-lg-3">
              <Label>cm</Label>
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-4">
              <Label>{props.t("height_cm")}</Label>
            </div>
            <div className="col-5 col-md-5 col-lg-5 col-lg-5">
              <Input
                fluid
                value={alturaInput}
                placeholder='0'
                // type="number"
                // onChange={(e, { value }) => setAlturaInput(value)}
                onChange={(e, { value }) => {
                  let res = Validator(value)
                  if (res) {
                    setAlturaInput(value)
                  }
                }}
              />
            </div>
            <div className="col-3 col-md-3 col-lg-3">
              <Label>cm</Label>
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-4">
              <Label>{props.t("weight_kg")}</Label>
            </div>
            <div className="col-5 col-md-5 col-lg-5 col-lg-5">
              <Input
                fluid
                value={pesoInput}
                placeholder='0'
                // type="number"
                // onChange={(e, { value }) => setPesoInput(value)}
                onChange={(e, { value }) => {
                  let res = Validator(value)
                  if (res) {
                    setPesoInput(value)
                  }
                }}
              />
            </div>
            <div className="col-3 col-md-3 col-lg-3">
              <Label>kg</Label>
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-4">
              <Label>{props.t("boxes")}</Label>
            </div>
            <div className="col-5 col-md-5 col-lg-5 col-lg-5">
              <Input
                fluid
                value={cajasInput}
                // type="number"
                // onChange={(e, { value }) => setCajasInput(value)
                placeholder='0'
                onChange={(e, { value }) => {
                  let res = Validator(value)
                  if (res) {
                    setCajasInput(value)
                  }
                }}
              />
            </div>
            <div className="col-3 col-md-3 col-lg-3">
              <Label />
            </div>
          </div>
          <br />
          {isChecked === "maritimo" ? (
            <>

              <div className="row" style={{ alignItems: "center" }}>
                <div className="col-4">
                  <Label>{props.t("cbm_m3")}</Label>
                </div>
                <div className="col-5 col-md-5 col-lg-5 col-lg-5">
                  <Input
                    fluid
                    value={cbmValue}
                  //disabled
                  //onChange={(e, { value }) => (setCbmInput(value))}
                  />
                </div>
                <div className="col-3 col-md-3 col-lg-3">
                  <Label>m3</Label>
                </div>
              </div>
              <br />
            </>
          ) : (
            ""
          )}
          <div className="row" style={{ alignItems: "center" }}>
            <div
              className="col-3"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <i
                className="fa-2x mr-2 fas fa-eraser"
                style={{ color: "#0060a8", marginTop: "7px", cursor: "pointer" }}
                title={props.t("clear")}
                onClick={() => handleEraser()}
              />
            </div>
            <div className="col-7">
              {isChecked === "maritimo" ? (
                <button
                  onClick={() => mCalcular(isChecked)}
                  disabled={
                    !(longitudInput && anchoInput && alturaInput) ||
                    maritimoResult.length >= 5 ||
                    !cajasInput
                    // ||
                    // !tipoContenedor
                  }
                  style={{ width: "17em" }}
                  className="btn btn-terceareo float-left"
                // disabled={!this.state.infoValid}
                >
                  {props.t("calculate")}
                </button>

              ) : isChecked === "terrestre" ?

                (
                  // <Button
                  //   fluid
                  //   onClick={() => mCalcular(isChecked)}
                  //   className={
                  //     longitudInput && anchoInput && alturaInput
                  //       ? "colorbuttom"
                  //       : ""
                  //   }
                  //   disabled={
                  //     !(longitudInput && anchoInput && alturaInput) ||
                  //     aereoResult.length >= 5
                  //   }
                  // >
                  //   Calcular Aereo
                  // </Button>

                  <button
                    onClick={() => mCalcular(isChecked)}
                    disabled={
                      !(longitudInput && anchoInput && alturaInput) ||
                      terrestreResult.length >= 5
                    }
                    style={{ width: "17em" }}
                    className="btn btn-terceareo float-left"
                  // disabled={!this.state.infoValid}
                  >
                    {props.t("calculate")}
                  </button>
                )

                : (
                  // <Button
                  //   fluid
                  //   onClick={() => mCalcular(isChecked)}
                  //   className={
                  //     longitudInput && anchoInput && alturaInput
                  //       ? "colorbuttom"
                  //       : ""
                  //   }
                  //   disabled={
                  //     !(longitudInput && anchoInput && alturaInput) ||
                  //     aereoResult.length >= 5
                  //   }
                  // >
                  //   Calcular Aereo
                  // </Button>

                  <button
                    onClick={() => mCalcular(isChecked)}
                    disabled={
                      !(longitudInput && anchoInput && alturaInput) ||
                      aereoResult.length >= 5
                    }
                    style={{ width: "17em" }}
                    className="btn btn-terceareo float-left"
                  // disabled={!this.state.infoValid}
                  >
                    {props.t("calculate")}
                  </button>
                )}
            </div>
            {/* <div className="col-2" style={{ padding: "0" }}>
              <Popup
                content={aereoInfo}
                style={{ textAlign: "justify", fontSize: '12px' }}
                position="top center"
                wide="very"
                trigger={<i class="fa-2x fas fa-info-circle mr-1" style={{color:'#0060a8'}}/>}
              />
            </div> */}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <br />
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-xs-12 col-md-5 col-lg-5">
              <Card fluid style={{ backgroundColor: " #0060a8" }}>
                <Card.Content>
                  <span style={{ fontWeight: 'bold', color: 'white', fontSize: '14px' }}>
                    {props.t("volumetric_weight")}
                  </span>
                </Card.Content>
              </Card>
            </div>
            {/* <div className="col-xs-12 col-md-7 col-lg-7 d-flex justify-content-end">
              <span className="tag-custom-value">
                NOTE: Los datos ingresados y resultados visualizados en esta ventana, son netamente orientativos. Los mismos no impactan de manera alguna en la coordinación de sus embarques.
              </span>
            </div> */}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          {/* <div className="row">
            <div className="col-12"> */}
          <Card fluid className="CARD UI REACT STRAP BORDER">
            <Card.Content>
              {/* Radio buttons */}
              <br />
              <div className="row">
                <CardBody>
                  <div className="col-xs-12 col-md-12 col-lg-12">
                    <div className="row">
                      <div className="col-xs-12 col-md-3 col-lg-3">
                        <div className="row">
                          <div
                            className="col-2"
                            style={{ marginTop: "4px" }}
                          >
                            <Radio
                              //label='Áereo'
                              //value='aereo'
                              checked={isChecked === "aereo"}
                              onChange={() => {
                                handleChange("aereo");
                              }}
                            />
                          </div>
                          <div
                            className="col-4" /* style={{backgroundColor:'red'}} */
                          >
                            <img
                              alt=""
                              src="https://magiclog.blob.core.windows.net/onboardpic/air_shipment.png"
                              style={{ width: '25px' }}
                            />
                            {/* <em
                              style={{ color: "#020E3A", fontSize: "20px" }}
                              className="icon-icono-aereo"
                            ></em> */}
                          </div>
                          <div
                            className="col-6"
                            style={{ marginTop: "4px" /* ,padding:'0' */ }}
                          >
                            <Label>{props.t("air_freight")}</Label>
                          </div>
                        </div>
                      </div>
                      <div className="col-xs-12 col-md-3 col-lg-3">
                        <div className="row">
                          <div
                            className="col-2"
                            style={{ marginTop: "4px" }}
                          >
                            <Radio
                              // label='Marítimo'
                              // value='maritimo'
                              checked={isChecked === "maritimo"}
                              onChange={() => {
                                handleChange("maritimo");
                              }}
                            />
                          </div>
                          <div
                            style={{
                              paddingLeft: "5px",
                            }}
                            className="col-4" /* style={{backgroundColor:'red'}} */
                          >
                            <img
                              alt=""
                              src="https://magiclog.blob.core.windows.net/onboardpic/sea_shipment.png"
                              style={{ width: '25px' }}
                            />
                            {/* <em
                              style={{ color: "#020E3A", fontSize: "20px" }}
                              className="icon-icono_maritimo"
                            ></em> */}
                          </div>
                          <div
                            className="col-6"
                            style={{ marginTop: "4px" }}
                          >
                            <Label>{props.t("ocean_freight")}</Label>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-xs-12 col-md-3 col-lg-3" /* style={{backgroundColor:'pink'}} */
                      >
                        <div className="row">
                          <div
                            className="col-2"
                            style={{ marginTop: "4px" }}
                          >
                            <Radio
                              //label='Áereo'
                              //value='aereo'
                              checked={isChecked === "terrestre"}
                              onChange={() => {
                                handleChange("terrestre");
                              }}
                            />
                          </div>
                          <div
                            className="col-4" /* style={{backgroundColor:'red'}} */
                          >
                            <img
                              alt=""
                              src="https://magiclog.blob.core.windows.net/onboardpic/road_shipment.png"
                              style={{ width: '25px' }}
                            />
                            {/* <em
                              style={{ color: "#020E3A", fontSize: "20px" }}
                              className="icon-icono_terrestre"
                            ></em> */}
                          </div>
                          <div
                            className="col-6"
                            style={{ marginTop: "4px" /* ,padding:'0' */ }}
                          >
                            <Label>{props.t("ground_freight")}</Label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </div>
              <br />
              <div className="row">
                <div
                  className="col-xs-12 col-md-12 col-lg-12" /* style={{backgroundColor:'brown'}} */
                >
                  <div className="row">
                    <div
                      className={
                        "col-xs-12 col-md-12 col-lg-4"
                        /* isChecked === "aereo" ? "col-3" : "col-4" */
                      }
                    >
                      {aereo()}
                      <br></br>
                    </div>
                    <div
                      className={
                        "col-xs-12 col-md-12 col-lg-8"
                        /* isChecked === "aereo" ? "col-8" : "col-8" */
                      } /* style={{backgroundColor:'yellow'}} */
                    >
                      <Card fluid>
                        <Card.Content>
                          {/* {isChecked === "maritimo" ? (
                            <div className="row">
                              <div className="col-12">
                                <CardBody>
                                  <Label
                                    style={{
                                      fontSize: "14px",
                                      color: "#666666",
                                    }}
                                  >
                                    <b>{props.t("container_type")}: </b>
                                  </Label>{" "}
                                  {containerLabel}
                                </CardBody>
                              </div>
                            </div>
                          ) : (
                            ""
                          )} */}
                          <Table
                            columns={
                              isChecked === "aereo"
                                ? columnsTable
                                : isChecked === "terrestre" ? columnsTableTerrestre : tableMaritimo
                            }
                            data={
                              isChecked === "aereo"
                                ? aereoResult
                                : isChecked === "terrestre" ? terrestreResult : maritimoResult
                            }
                            options={{
                              large: true,
                              downloads: {
                                pdf: false,
                                xlsx: false,
                              },
                            }}
                          />


                          {/* {aereoCardResult} */}

                          <div className="row">
                            <div className="col-11">
                              <p className="tag-custom-value">
                                {props.t("total_weight_vol_legend")}
                              </p>
                            </div>
                            {/* <div
                              className="col-1"
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Popup
                                open={isSendMail}
                                basic
                                position="top right"
                                size="large"
                                on="click"
                                trigger={
                                  <em
                                    class="fa-2x mr-2 far fa-envelope"
                                    onClick={() => sendMail(props)}
                                    title={props.t("send_email")}
                                    style={{
                                      cursor: "pointer",
                                      color:
                                        isChecked === "aereo"
                                          ? colorEnvelopAereo
                                          : isChecked === "terrestre" ? colorEnvelopTerrestre : colorEnvelopMaritimo,
                                    }}
                                  />
                                }
                              >
                                <div>
                                  <div className="row">
                                    <div
                                      className="col-12"
                                      style={{ textAlign: "center" }}
                                    >
                                      <Header as="h4">
                                        <Icon
                                          style={{
                                            background: "transparent",
                                          }}
                                          color="green"
                                          name="check circle outline"
                                        />
                                      </Header>
                                    </div>
                                  </div>
                                  <div style={{ height: 10 }}></div>
                                  <div className="row">
                                    <div
                                      className="col-12"
                                      style={{
                                        color: "green",
                                        textAlign: "center",
                                      }}
                                    >
                                      {props.t("result_send_tomail")}
                                    </div>
                                  </div>
                                </div>
                              </Popup>
                            </div> */}
                          </div>
                        </Card.Content>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            </Card.Content>
          </Card>
          {/* </div>
          </div> */}
        </div>
      </div>
      <br />

      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <Card
                Card
                fluid
                header={props.t("total_weight_vol")}
                style={{ textAlign: "justify", fontSize: '12px', color: "#020e3a" }}
                className="CARD UI REACT STRAP BORDER"
                description={
                  <div>
                    <p className="tag-custom-value">
                      {props.t("total_weight_vol_desc_1")}
                    </p>
                    <p className="tag-custom-value">
                      {props.t("total_weight_vol_desc_2")}
                    </p>
                    <p className="tag-custom-value">
                      {props.t("total_weight_vol_desc_3")}
                      <b>
                        {props.t("total_weight_vol_desc_4")} {isChecked === "aereo" ? 6000 : isChecked === "terrestre" ? 3000 : 5000}
                      </b>
                      .{" "}
                    </p>
                    {/* <p className="tag-custom-value">
                      {props.t("total_weight_vol_legend")}
                    </p> */}
                  </div>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withNamespaces()(Calculadora);
